import { RejectCompany } from './RejectCompany'

export default RejectCompany
